import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteBusFuelGroup } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteBusFuelGroupButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { busFuelGroupId, dispatchDeleteBusFuelGroup } = this.props;
    dispatchDeleteBusFuelGroup({ busFuelGroupId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteBusFuelGroupButton.propTypes = {
  busFuelGroupId: PropTypes.number.isRequired,
  dispatchDeleteBusFuelGroup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteBusFuelGroup: deleteBusFuelGroup,
};

export default connect(null, mapDispatchToProps)(DeleteBusFuelGroupButton);
